module.exports = __webpack_public_path__ + "static/redwood-2-20b47cc012bf8d472ef41588a4a53f6c.jpg";